module.exports = __webpack_public_path__ + "img/swingcycle5.1d0caa2f.svg";